import './Hero.css';

const cubes = [
  {
    label: 'Web Dev',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"/><polyline points="8 6 2 12 8 18"/></svg>,
  },
  {
    label: 'AI & ML',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a4 4 0 0 1 4 4c0 1.5-.8 2.8-2 3.5V12l3 3-3 1v2l-2-1-2 1v-2l-3-1 3-3V9.5A4 4 0 0 1 8 6a4 4 0 0 1 4-4z"/></svg>,
  },
  {
    label: 'Cloud',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/></svg>,
  },
  {
    label: 'Research',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
  },
  {
    label: 'Analytics',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  },
  {
    label: 'Support',
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>,
  },
];

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg-glow" />
      <div className="hero-bg-glow hero-bg-glow-2" />
      <div className="container hero-inner">
        <div className="hero-content">
          <span className="section-tag">Digital Solutions That Drive Growth</span>
          <h1 className="hero-title">
            We Build Scalable<br />
            <span className="gradient-text">Digital Solutions</span>
          </h1>
          <p className="hero-desc">
            We help startups and businesses turn ideas into powerful digital
            products using modern technologies.
          </p>
          <div className="hero-actions">
            <a href="#contact" className="btn-primary">Get a Free Consultation →</a>
            <a href="#portfolio" className="btn-outline">View Our Work</a>
          </div>
        </div>
        <div className="hero-visual">
          <div className="cube-grid">
            {cubes.map((c, i) => (
              <div key={i} className={`cube cube-${i + 1}`}>
                <div className="cube-icon">{c.icon}</div>
                <span className="cube-label">{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
